
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcast/[slug]",
      function () {
        return require("private-next-pages/podcast/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcast/[slug]"])
      });
    }
  